import { SyllabaryColumn } from '../../../../domain/carerecipient/SyllabaryColumn';

export function syllabaryColumnId(syllabaryColumn: SyllabaryColumn): string {
  return `syllabaryColumn:${syllabaryColumn}`;
}
